export default __webpack_public_path__ + "adf86f85f18ccc554802be1742d3977b.png";